export default __webpack_public_path__ + "static/media/mobile.0de9ce8e.png";